<template>
    <transition>
        <div class="forget-container-inner">
            <h4 class="forget-title">{{$t('forget_passwd')}}</h4>
            <p class="forget-subtitle">{{$t('reinput_new_passwd')}}</p>
            <el-form
                :model="formData"
                :rules="formRules"
                ref="formRef"
                @submit.native.prevent="confirm"
            >
                <el-form-item prop="password">
                    <el-input
                        :type="formData.passType"
                        v-model="formData.password"
                        :placeholder="$t('new_passwd')"
                    >
                        <i
                            class="iconfont show-pass-icon"
                            :class="[formData.passType === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                            slot="suffix"
                            @click="toggleShowPasswd(formData, 'passType')"
                        ></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="rePasswd">
                    <el-input
                        :type="formData.rePassType"
                        v-model="formData.rePasswd"
                        :placeholder="$t('new_passwd_again')"
                    >
                        <i
                            class="iconfont show-pass-icon"
                            :class="[formData.rePassType === 'password' ? 'icon-icon_visiblex' : 'icon-icon_invisiblex']"
                            slot="suffix"
                            @click="toggleShowPasswd(formData, 'rePassType')"
                        ></i>
                    </el-input>
                </el-form-item>
                <button class="form-btn">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        const validatePass = (rule, value, callback) => {
            if (this.formData.rePasswd !== "") {
                this.$refs.formRef.validateField("rePasswd");
            }
            callback();
        };
        const validatePass2 = (rule, value, callback) => {
            if (value !== this.formData.password) {
                callback(new Error(this.$t("passwd_incons")));
            } else {
                callback();
            }
        };
        return {
            formData: {
                password: "",
                rePasswd: "",
                passType: "password",
                rePassType: "password"
            },
            formRules: {
                password: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd")
                    },
                    {
                        validator: validatePass,
                        trigger: "blur"
                    }
                ],
                rePasswd: [
                    {
                        required: true,
                        message: this.$t("reinput_passwd")
                    },
                    {
                        validator: validatePass2,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                this.$req
                    .post("saveuserpasswd", {
                        area_code: this.$parent.code,
                        account: this.$parent.account,
                        encryption_code: this.$parent.encryption_code,
                        token: this.$parent.token,
                        password: this.formData.password,
                        password2: this.formData.rePasswd
                    })
                    .then(resp => {
                        if (resp.data.code === "2000") {
                            this.$msg.success(this.$t("set_pw_success"));
                            this.resetFields();
                            this.$store.dispatch("updateForgetFlow", {
                                show: false,
                                type: this.$store.getters.forgetFlow.type
                            });
                        } else {
                            this.$msg.error(resp.data.msg);
                        }
                    });
            });
        },
        toggleShowPasswd(form, type) {
            if (form[type] === "password") {
                form[type] = "text";
            } else {
                form[type] = "password";
            }
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        }
    }
};
</script>

<style scoped>
.show-pass-icon {
    font-size: 20px;
    padding-right: 5px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Forget/Password.vue